import { useEffect, useState } from "react";
import CheckLogin from "../services/CheckLogin";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";

function NotAuthProvider({ children }) {
     const host = `${process.env.REACT_APP_LOCAL_HOST}`;
     const [wait, setWait] = useState(true);
     const navigate = useNavigate();

     useEffect(() => {
          const token = localStorage.getItem("token");
          if (!token || token === "null" || token === "undefined") {
               setWait(false);
               return;
          }

          const checkLogin = async () => {
               try {
                    const result = await CheckLogin(host);
                    if (result?.data?.account_role === "teacher") {
                         navigate("/dashboard", { replace: true });
                         return;
                    }
                    if (result?.data?.account_role) {
                         localStorage.removeItem("token");
                    }
               } catch (err) {
                    console.error(err);
                    localStorage.removeItem("token");
               } finally {
                    setWait(false);
               }
          };
          checkLogin();
     }, [navigate, host]);

     return (
          <AuthContext.Provider value={{ wait, setWait }}>
               {children}
          </AuthContext.Provider>
     );

}

export default NotAuthProvider;
